import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useI18nContext } from "#/shared/hooks";
type ProjectBrowserEmptyProps = {
  searchQuery?: string;
  hasFilters?: boolean;
};
export const ProjectBrowserEmpty: React.FC<ProjectBrowserEmptyProps> = t0 => {
  const $ = _c(9);
  const {
    searchQuery,
    hasFilters
  } = t0;
  const {
    LL
  } = useI18nContext();
  let t1;
  if ($[0] !== LL || $[1] !== hasFilters || $[2] !== searchQuery) {
    t1 = () => {
      if (searchQuery) {
        return LL.NO_PROJECTS_FOUND_FOR_SEARCH({
          query: searchQuery
        });
      }
      if (hasFilters) {
        return LL.NO_PROJECTS_MATCH_FILTERS();
      }
      return LL.NO_PROJECTS_FOUND();
    };
    $[0] = LL;
    $[1] = hasFilters;
    $[2] = searchQuery;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getMessage = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 200,
      p: 4
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getMessage) {
    t3 = getMessage();
    $[5] = getMessage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Box sx={t2}><Stack spacing={1} alignItems="center"><Typography variant="body1" color="text.secondary">{t3}</Typography></Stack></Box>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};